import Helper from "../../core/libraries/Helper";
import { Types } from "./actions";
import { ISubscriptionState } from "./types";

const initialState: ISubscriptionState = {
    subscriptions: undefined
};

export const SubscriptionReducer = (state: ISubscriptionState = initialState, action: any): ISubscriptionState => {
    switch (action.type) {
        case Types.SET_MY_SUBSCRIPTIONS: {
            let currentState: ISubscriptionState = Object.assign({}, state);
            currentState.subscriptions = action.data.subscriptions;
            Helper.runNewTask(() => {
                if (!!action.data.callback) {
                    action.data.callback();
                }
            });
            return currentState;
        }
    }
    return state;
}